// Children inside a Tooltip/HoverCard trigger marked with this attribute won't open it on hover.
export const HOVER_CONTAIN_SELECTOR = '[data-hover="contain"]';
export const hoverContainProps = { 'data-hover': 'contain' } as const;
